import utils from 'helpers/utils';
import {
    FETCH_PRODUCT_MEMBERSHIPS,
    FETCH_PRODUCT_MEMBERSHIPS_FAILURE,
    FETCH_PRODUCT_MEMBERSHIPS_SUCCESS,
    FETCH_PRODUCT_MEMBERSHIP,
    FETCH_PRODUCT_MEMBERSHIP_FAILURE,
    FETCH_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

export const fetchProductMemberships = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 24,
        sort_by: payload.field ? payload.field : 'name',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'desc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (payload.product_id) {
        params.product_id = [
            payload.product_id,
        ];
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_PRODUCT_MEMBERSHIPS,
        payload: params,
    };
};

export const fetchProductMembershipsFailure = (error) => {
    return {
        type: FETCH_PRODUCT_MEMBERSHIPS_FAILURE,
        error: error,
    };
};

export const fetchProductMembershipsSuccess = (response) => {
    return {
        type: FETCH_PRODUCT_MEMBERSHIPS_SUCCESS,
        response: response,
    };
};

export const fetchProductMembership = (payload) => {
    return {
        type: FETCH_PRODUCT_MEMBERSHIP,
        payload: payload,
    };
};

export const fetchProductMembershipFailure = (error) => {
    return {
        type: FETCH_PRODUCT_MEMBERSHIP_FAILURE,
        error: error,
    };
};

export const fetchProductMembershipSuccess = (response) => {
    return {
        type: FETCH_PRODUCT_MEMBERSHIP_SUCCESS,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/product-memberships/fetchProductMemberships.js